export const SET_DRAG_STATUS = "SET_DRAG_STATUS";


export function setDragStatus(status) {
  return {type: SET_DRAG_STATUS, status};
}